import React from 'react';

export const WarningTriangleIcon = ({
  width = 22,
  height = 22,
  color = '#FDA92E',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.624 4.422c.841-1.496 2.994-1.496 3.834 0l6.138 10.912c.825 1.467-.234 3.278-1.916 3.278H4.403c-1.683 0-2.742-1.81-1.917-3.278L8.624 4.422Zm3.017 10.89a1.1 1.1 0 1 1-2.2.001 1.1 1.1 0 0 1 2.2 0Zm-1.1-8.8a1.1 1.1 0 0 0-1.1 1.1v3.3a1.1 1.1 0 0 0 2.2 0v-3.3a1.1 1.1 0 0 0-1.1-1.1Z"
      fill={color}
    />
  </svg>
);
